import { CombineFieldStatIcon } from "./SummaryStatIcons";
import { SummaryStatVariant } from "../SummaryStatCard";

export const harvestedTons: SummaryStatVariant = {
  icon: <CombineFieldStatIcon />,
  label: "Harvested Tons",
};
